import React from 'react';
import { Box, Button, Grid, Modal, Typography } from '@mui/material';

interface ConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  confirmButtonText: string;
  onConfirm: () => void;
  cancelButtonText: string;
  onCancel: () => void;
}

const ConfirmationModal = ({
  open,
  onClose,
  title,
  description,
  confirmButtonText,
  onConfirm,
  cancelButtonText,
  onCancel,
}: ConfirmationModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-modal"
      aria-describedby="confirmation-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90dvw', md: 400 },
          maxWidth: '500px',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: '20px',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        {description && (
          <Typography variant="body1" component="p">
            {description}
          </Typography>
        )}
        <Grid container justifyContent="flex-end" spacing={2}>
          <Grid item>
            <Button variant="outlined" color="secondary" onClick={onCancel}>
              {cancelButtonText}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                onConfirm();
                onClose();
              }}
              sx={{ color: '#fff' }}
            >
              {confirmButtonText}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
